module.exports = __webpack_public_path__ + "img/exceed-sign.64e0d1a8.svg";